module.exports = __webpack_public_path__ + "media/images/pc/specials/common/store_utsunomiya-ba5ee75ff50d9e717565747a68238ca8.jpg";